import React, { Component } from 'react';
import FancyInput from "./FancyInput";
import globals from "../globals";

class Addressify extends Component {

	constructor(props) {
		super(props);

		this.state = {
			address: globals.getSessionVar('address'),
			addressList: []
		};
	}

	componentDidMount() {
		if (this.state.address.length > 0) {
			document.querySelector('.addressify .input').classList.add('input--filled');
		}

		this.props.handleSetAddress(this.state.address);
	}

	handleKeyDown(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			this.handleEnterPress();
		}
	}

	handleChangeAddress(event) {
		this.setState({address: event.target.value}, () => {
			this.getAddresses();
		});

		this.props.handleSetAddress(event.target.value);
	}

	handleAddressClick(address, event) {
		event.preventDefault();
		this.setAddress(address);
	}

	handleEnterPress() {
		if (this.state.addressList.length > 0) {
			this.setAddress(this.state.addressList[0].value);
		}
	}

	setAddress(address) {
		this.setState({
			address: address,
			addressList: []
		}, () => {
			globals.setSessionVar('address', address);
		});

		this.props.handleSetAddress(address);
	}

	getAddresses() {
		if (this.state.address.length > 4) {
			this.loader.style.display = 'block';
			clearTimeout(this.sqTimer);

			this.sqTimer = setTimeout(() => {
				fetch('/api/search/' + this.state.address)
					.then(result => result.json())
					.then((result) => {
						this.loader.style.display = 'none';
						if (result.length > 0) {
							this.setState({
								addressList: result
							});
						} else {
							this.setState({
								addressList: [
									{id: '0', label: 'No address found.', value: this.state.address}
								]
							});
						}
					});
			}, 500);
		}
	}

	render() {
		const AddressList = this.state.addressList.map((item, key) => {
			return (
				<a key={key} href="#" onClick={event => this.handleAddressClick(item.value, event)}>{item.label}</a>
			);
		});

		return (
			<div className="addressify">
				<FancyInput
					name="address"
					label={(this.props.label ? this.props.label : 'Address *')}
					value={this.state.address}
					handleChange={this.handleChangeAddress.bind(this)}
					handleKeyDown={this.handleKeyDown.bind(this)}
				/>
				{(this.state.addressList.length > 0 ?
					<div className="address-list">
						{AddressList}
					</div>
					: '')}
				<div className="inline-loader" ref={el => this.loader = el}>
					<img src="/images/loader-anim-inline.svg" alt="..." className="not-ie" />
					<img src="/images/loader-anim-inline-ie.gif" alt="..." className="ie" style={{width: '60px'}} />
				</div>
			</div>
		);
	}

}

export default Addressify;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Addressify.js